import { render, staticRenderFns } from "./WorkIconRepair.vue?vue&type=template&id=7c979e8a"
import script from "./WorkIconRepair.vue?vue&type=script&lang=js"
export * from "./WorkIconRepair.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports